// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__mZvL2","textarea":"styles_textarea__3SNIF"};